import { Breadcrumb } from "@components/anti"
import { useScrollAnim } from "@components/hooks/hooks"
import { useRouter } from "next/router"
import ProjectGalleryCard from "./project-gallery-card"

export default function ProjectGalleryCategories({ categories }) {
  const { locale } = useRouter()
  const [trigger, anim] = useScrollAnim()
  const [trigger2, anim2] = useScrollAnim()
  const title = locale === "en" ? "Project Gallery & Events" : "Proyek & Event"
  return (
    <>
      <section className="sc-project-gallery-header" ref={trigger}>
        <div className="container py-3">
          <Breadcrumb path={`/${title}`} className={anim(1)} />
          <h1 className={anim(2)}>{title}</h1>
        </div>
      </section>
      <section className="sc-project-gallery-categories" ref={trigger2}>
        <div className="container py-3">
          <div className="row">
            {categories?.map((category, index) => (
              <div className="col-12 col-md-4 mb-4" key={index}>
                <ProjectGalleryCard
                  image={category.images?.desktopUrl}
                  imageMobile={category.images?.mobileUrl}
                  title={category.title}
                  link={`/project-gallery/${category.slug}-${category.id}`}
                  className={anim2(index + 1)}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
